module.exports = __webpack_public_path__ + "static/media/newsBg.7b88d061.webp";